import { render, staticRenderFns } from "./GoodsSwimWearAdminView.vue?vue&type=template&id=96e857c2&"
import script from "./GoodsSwimWearAdminView.vue?vue&type=script&lang=js&"
export * from "./GoodsSwimWearAdminView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSwimWearAdminView.vue?vue&type=style&index=0&id=96e857c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports